import { MCAXS130DownloadCsvRequest } from 'types/MCAXS130/MCAXS130DownloadCsvRequest'

const MCAXS130downloadValues: MCAXS130DownloadCsvRequest = {
  requestId: '',
  template: '',
  targetCount: ''
}

export { MCAXS130downloadValues }
